
<template>
  <div class="remarks_class">
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      :default-sort="{ prop: 'createTime' }"
      @sort-change="handleSortChange"
    >
      <el-table-column
        prop="createTime" sortable="custom" :label="$t('userManage.time')"
        align="center" width="180"
      />
      <el-table-column
        prop="createUserName" :label="$t('collectionCenter.controlsEmployee')"
        align="center" width="120"
      />
      <el-table-column
        prop="siteName" :label="$t('collectionCenter.belongSite')"
        align="center" width="120"
      />
      <el-table-column
        prop="operationType" :label="$t('collectionCenter.operation')"
        align="center" width="90"
      />
      <el-table-column
        prop="remark" :label="$t('collectionCenter.detail')"
        align="center"
      />
    </el-table>
  </div>
</template>

<script>
import { queryOrderRemark } from '@/api/bulkExpressApi';
export default {
  props: {
    remarkId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      reId: this.remarkId,
      tableData: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      queryOrderRemark(this.reId).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
        }
      });
    },
    handleSortChange({ column, prop, order }) {
      if (prop === 'createTime') {
        this.tableData.sort((a, b) => {
          const dateA = new Date(a[prop]);
          const dateB = new Date(b[prop]);
          return order === 'ascending' ? dateA - dateB : dateB - dateA;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
